import { Theme, css } from '@emotion/react';

export const IMAGE_SIZE_MOBILE = 92;
export const IMAGE_SIZE_DESKTOP = 108;

const cardPaddingMobile = (spacing: Theme['spacing']) => spacing(1);
const cardPaddingDesktop = (spacing: Theme['spacing']) => spacing(1.5);
const quantitySizeMobile = (spacing: Theme['spacing']) => spacing(2.5);
const quantitySizeDesktop = (spacing: Theme['spacing']) => spacing(2.5);

export const itemizedCardRootStyles = () => css`
  height: 100%;
  border-radius: 0;
  border-width: 0;
  overflow: visible;
`;

export const itemizedCardActionAreaRootStyles = ({
  spacing,
  breakpoints,
  colors,
  transitions,
}: Theme) => css`
  border: 1px solid ${colors.borderDefault};
  background-color: ${colors.bgDefault};
  box-shadow: 0 0 0 2px transparent;
  display: flex;
  align-items: stretch;
  padding: ${cardPaddingMobile(spacing)}px;
  position: relative;
  min-height: ${IMAGE_SIZE_MOBILE} + 2 * ${cardPaddingMobile(spacing)}px;
  height: 100%;
  transition:
    ${transitions.duration.short}ms box-shadow ${transitions.easing.easeInOut},
    ${transitions.duration.short}ms border-color ${transitions.easing.easeInOut};
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${colors.bgDefault};
      border-bottom-color: ${colors.borderPrimaryBase};
      color: ${colors.fgPrimaryBase};
      & .MuiCardActionArea-focusHighlight {
        opacity: 0;
      }
    }
  }
  &.Mui-focusVisible {
    border-color: ${colors.borderPrimaryBase};
    box-shadow: 0 0 0 2px ${colors.borderPrimaryBase};
    & .MuiCardActionArea-focusHighlight {
      opacity: 0;
    }
  }
  ${breakpoints.up('md')} {
    padding: ${cardPaddingDesktop(spacing)}px;
    min-height: ${IMAGE_SIZE_DESKTOP} + 2 * ${cardPaddingDesktop(spacing)}px;
  }
`;

export const itemizedCardContentStyles = (
  { spacing, breakpoints }: Theme,
  extraSpacing: boolean
) => css`
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: ${IMAGE_SIZE_MOBILE}px;
  min-width: 0;
  padding: ${spacing(1)}px 0 ${spacing(1)}px ${spacing(1)}px;
  margin-right: ${extraSpacing ? quantitySizeMobile(spacing) : 0}px;
  ${breakpoints.up('md')} {
    min-height: ${IMAGE_SIZE_DESKTOP}px;
    margin-right: ${extraSpacing ? quantitySizeDesktop(spacing) : 0}px;
  }
`;

export const itemizedCardQuantityStyles = ({ spacing, breakpoints, colors }: Theme) => css`
  line-height: ${quantitySizeMobile(spacing)}px;
  color: ${colors.fgContrast};
  background: ${colors.fgPrimaryBase};
  position: absolute;
  right: ${cardPaddingMobile(spacing)}px;
  top: ${cardPaddingMobile(spacing)}px;
  min-height: ${quantitySizeMobile(spacing)}px;
  min-width: ${quantitySizeMobile(spacing)}px;
  z-index: 2;
  ${breakpoints.up('md')} {
    line-height: ${quantitySizeDesktop(spacing)}px;
    right: ${cardPaddingDesktop(spacing)}px;
    top: ${cardPaddingDesktop(spacing)}px;
    min-height: ${quantitySizeDesktop(spacing)}px;
    min-width: ${quantitySizeDesktop(spacing)}px;
  }
`;

export const itemizedCardImageStyles = ({ spacing, breakpoints }: Theme) => css`
  height: ${IMAGE_SIZE_MOBILE}px;
  position: relative;
  width: ${IMAGE_SIZE_MOBILE}px;
  margin-left: ${cardPaddingMobile(spacing)}px;
  z-index: 1;
  ${breakpoints.up('md')} {
    margin-left: ${cardPaddingDesktop(spacing)}px;
    height: ${IMAGE_SIZE_DESKTOP}px;
    width: ${IMAGE_SIZE_DESKTOP}px;
  }
  .Mui-disabled & {
    opacity: 0.5;
  }
`;
